Apt.fn.make('directory.relevant', {
	/**
	 * Display relevant profiles
	 *
	 * @param {Object} options
	 * @returns {Object}
	 */
	init(options = {}) {
		const scope = this;
		const $target = $$('relevantProfiles', options.context);

		options.resource = 'profiles/relevant';

		scope.index = Apt.fn.index().init({
			app: LS.util.uid(),
			view: 'directory.relevant',
			resource: options.resource,
			target: $target,
			model: {
				loading: true
			},
			flash: false,
			static: true,
			filters:Object.assign({
				limit: 6,
				near: $.context('location.center') || LS.user.center()
			}, options.filters),
			updated: data => {
				$.exec(options.updated, {
					args: [data]
				});

				if (! data.results.length) {
					$target.parent()
						.hide();
				}
			},
			unload: () => {
				const app = scope.index.app;

				if (! app) {
					return;
				}

				$.exec(options.unload);
			}
		});

		return scope;
	},

	/**
	 * Destroy module
	 *
	 * @private
	 */
	_destruct() {
		LS.util.destroy(this, 'index');
	}
});